export default __webpack_public_path__ + "static/media/hotelroom1.24c453a0.jpg";